<template>
 <v-app id="app">
  <main-page></main-page>
 </v-app>

</template>

<script>
    import MainPage from './components/PageComponents/MainPage'

    export default {
        name: 'App',
        components: {
            MainPage
        }
    }


</script>
<style lang="scss">
</style>
